<template>
  <base-form
    class="special-function-base-query"
    ref="queryForm"
    v-model="baseQueryFormObj"
    labelWidth="120px"
    :form-items="baseFormItems"
    inline
  >
  </base-form>
</template>
<script>
export default {
  name: 'special-function-base-query',
  data() {
    return {
      baseQueryFormObj: {
        product: '',
        bid: '',
      },
      baseFormItems: [
        {
          label: 'Product',
          prop: 'product',
          component: 'form-select',
          value: '',
          bind: {
            placeholder: 'please select',
            filterable: true,
            options: [],
          },
          on: {
            change: (val) => {
              this.baseFormItems[0].value = val
              this.getBrandOrField(val)
            },
          },
        },
        {
          label: 'Special Function',
          prop: 'bid',
          labelWidth: '200px',
          component: 'form-select',
          value: '',
          bind: {
            placeholder: 'please select',
            filterable: true,
            options: [],
          },
          on: {
            change: () => {
              this.$emit('change', this.baseQueryFormObj)
            },
          },
        },
      ],
    }
  },
  created() {
    this.getProduct()
  },
  methods: {
    getProduct() {
      this.$get('special/getProduct').then((resp) => {
        if (resp.data.code == 0) {
          var opts = []
          for (var item of resp.data.data) {
            opts.push({
              value: item.configCode,
              label: item.productCode,
            })
          }
          this.baseFormItems[0].bind.options = opts
        } else {
          console.log('请求发生错误=>', resp.data)
        }
      })
    },
    getBrandOrField(product) {
      this.baseFormItems[1].value = null
      this.$emit('change', {
        product,
        bid: null,
      })
      this.$get(
        'brandOrField/getType?type=specialFunctionQuery&product=' + product
      ).then((resp) => {
        if (resp.data.code == 0) {
          var opts = []
          for (var item of resp.data.data) {
            opts.push({
              value: item.id,
              label: item.brand,
            })
          }
          this.baseFormItems[1].bind.options = opts
        } else {
          console.log('请求发生错误=>', resp.data)
        }
      })
    },
  },
}
</script>